module.exports = __webpack_public_path__ + "img/banner_logo.fd8a3aa4.png";